import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";

const ActualizarHistorialMultiplesPagosCotizaciones = async ({idCotizacion, pagos, tipoEvento, idUsuario, detalles}) => {
  try {
    const response = await axios.get(`${BACKEND}/api/cotizaciones/${idCotizacion}`, {withCredentials: true});

    const historial = response.data.historialCambiosPagos || [];

    // Crear un array de nuevos registros de historial para cada pago
    const nuevosRegistros = pagos.map(pago => ({
      usuario: idUsuario,
      idPago: pago.id,
      tipoEvento: tipoEvento,
      fecha: new Date().toISOString(),
      detalles: detalles
    }));

    const nuevoHistorial = [
      ...historial.map((h) => ({
        ...h,
        usuario: h.usuario.id
      })),
      ...nuevosRegistros
    ];

    await axios.put(`${BACKEND}/api/cotizaciones/${idCotizacion}`, {
      historialCambiosPagos: nuevoHistorial,
    }, {withCredentials: true});

  } catch (error) {
    console.log(error)
    toast.error("Error al actualizar el historial de pagos de la cotización: " + error);
  }
}

export default ActualizarHistorialMultiplesPagosCotizaciones;
